import { OnInit, Component } from '@angular/core';
import { LayoutService } from '../../service/app.layout.service';
import { RouterModule } from '@angular/router';
import { AppMenuitemComponent } from './app.menuitem.component';
import { MenuItem } from 'primeng/api';
import { DividerModule } from 'primeng/divider';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../pages/user/services/user.service';
import { User } from '../../../pages/user/models/user.type';
import { environment } from '../../../../environments/environment';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [RouterModule, AppMenuitemComponent, DividerModule, TranslateModule, NgxPermissionsModule],
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  model: MenuItem[] = [];
  user: User;
  role: string;
  env;

  constructor(
    public layoutService: LayoutService,
    private readonly translate: TranslateService,
    private readonly userService: UserService,
    private readonly permissionService: NgxPermissionsService,
  ) {}

  ngOnInit() {
    this.env = environment.environment;
    this.user = this.userService.getUser();
    let items: MenuItem[] = [
  /*     {
        label: 'menu.dashboard',
        icon: 'pi pi-fw pi-home',
        routerLink: ['/dashboard'],
      }, */
      {
        label: 'menu.catalog',
        icon: 'pi pi-fw pi-list',
        items: [
          {
            label: 'menu.catalogProduct',
            icon: 'pi pi-file',
            routerLink: ['/seller/catalog'],
            routerLinkActiveOptions: ['/seller/catalog/:id'],
          },
          /* { label: 'menu.archivedProducts', icon: 'pi pi-inbox' }, */
        ],
      },
      {
        label: 'menu.import',
        icon: 'pi pi-file',
        items: [
          {
            label: 'menu.importCatalog',
            icon: 'pi pi-file-import',
            routerLink: ['/import/catalog-import'],
          },
          {
            label: 'menu.modelFile',
            icon: 'pi pi-file-export',
            routerLink: ['/import/export'],
          },
     /*      {
            label: 'menu.importSetting',
            icon: 'pi pi-file-edit',
            routerLink: ['/import/settings'],
          }, */
        ],
      },
      { label: 'menu.sellerShop', icon: 'pi pi-fw pi-shop', routerLink: ['/seller/shop'] },
      {
        label: 'menu.settings',
        icon: 'pi pi-fw pi-cog',
        items: [
          { label: 'menu.taxonomy', icon: 'pi pi-folder', routerLink: ['/settings/taxonomy'] },
          {
            label: 'menu.rights',
            icon: 'pi pi-user',
            routerLink: ['/settings/users'],
            visible:
              this.permissionService.getPermission('PERMISSION_MANAGE_USERS') ||
              this.permissionService.getPermission('PERMISSION_SUPER_ADMIN')
                ? true
                : false,
          },
        ],
      },
       { label: 'menu.help', icon: 'pi pi-fw pi-question-circle', routerLink: ['/help'] },
       { label: 'menu.documentation', icon: 'pi pi-book', routerLink: ['/docapi'] }, 
    ];
    if (this.userService.hasRole(['ROLE_OPERATOR', 'ROLE_OPERATOR_ADMIN', 'ROLE_SUPER_ADMIN'])) {
      items = [
    /*     {
          label: 'menu.dashboard',
          icon: 'pi pi-fw pi-home',
          routerLink: ['/dashboard'],
        }, */
        {
          label: 'menu.catalog',
          icon: 'pi pi-fw pi-list',
          items: [
            {
              label: 'menu.catalogProduct',
              icon: 'pi pi-file',
              routerLink: ['/operator/catalog'],
              routerLinkActiveOptions: ['/operator/catalog/:id'],
            },
           /*  { label: 'menu.archivedProducts', icon: 'pi pi-inbox' }, */
          ],
        },
        {
          label: 'menu.import',
          icon: 'pi pi-file',
          visible:
          this.permissionService.getPermission('PERMISSION_SUPER_ADMIN')   || this.permissionService.getPermission('PERMISSION_IMPORT_OPERATOR_SELLER') 
            ? true
            : false,
          items: [
            {
              label: 'menu.importCatalog',
              icon: 'pi pi-file-import',
              routerLink: ['/import/catalog-import'],
            },
            {
              label: 'menu.modelFile',
              icon: 'pi pi-file-export',
              routerLink: ['/import/export'],
            },
      /*       {
              label: 'menu.importSetting',
              icon: 'pi pi-file-edit',
              routerLink: ['/import/settings'],
            }, */
          ],
        },
        {
          label: 'menu.operatorShop',
          icon: 'pi pi-fw pi-shop',
          routerLink: ['/operator/shop'],
          routerLinkActiveOptions: ['/operator/shop/:id'],
        },
        {
          label: 'menu.settings',
          icon: 'pi pi-fw pi-cog',
          items: [
            { label: 'menu.taxonomy', icon: 'pi pi-folder', routerLink: ['/settings/taxonomy'] },
            {
              label: 'menu.rights',
              icon: 'pi pi-user',
              routerLink: ['/settings/users'],
              visible:
                this.permissionService.getPermission('PERMISSION_MANAGE_ROLES_AND_USERS') ||
                this.permissionService.getPermission('PERMISSION_MANAGE_ROLES_AND_USERS_RESTRICTED') ||
                this.permissionService.getPermission('PERMISSION_SUPER_ADMIN')
                  ? true
                  : false,
            },
            { label: 'menu.notifications', icon: 'pi pi-bell', routerLink: ['/settings/notifications'],
              visible:this.permissionService.getPermission('PERMISSION_SUPER_ADMIN') ||
              this.permissionService.getPermission('PERMISSION_MANAGE_NOTIFICATIONS')
                  ? true
                  : false
             },
          ],
        },
         { label: 'menu.help', icon: 'pi pi-fw pi-question-circle', routerLink: ['/help'] }, 
         { label: 'menu.documentation', icon: 'pi pi-book', routerLink: ['/docapi'] }, 
      ];
    }
    this.model = [
      {
        items: items,
      },
    ];
  }
}
